export default {
  title: 'Agency Report',
  filter: {
    placeholders: {
      keyword: 'Search Client ID / Nickname / Email',
      superior: 'Superior ID / Nickname',
      range: 'Data Range',
    },
    confirm: 'Confirm',
    reset: 'Reset',
    rangeOptions: {
      3: 'All',
      0: 'Self',
      1: 'Direct Subordinate',
      2: 'Indirect Subordinate',
    },
  },
  table: {
    kycStatusText: {
      verified: 'Verified',
      unverified: 'Unverified',
    },
    levelUnit: 'Level',
    lotUnit: 'Lot',
    columns: {
      memberId: 'Client ID',
      nickname: 'Nickname',
      email: 'Email',
      country: 'Country',
      kycStatus: 'KYC Status',
      agentLevel: 'Agent Level',
      parentId: 'Superior ID',
      parentNickname: 'Superior Nickname',
      totalCustomers: 'Total Customers',
      agentCount: 'Agents',
      directCustomers: 'Direct Customers',
      directAgentCount: 'Direct Agents',
      deposit: 'Deposit',
      withdraw: 'Withdrawal',
      netDeposit: 'Net Deposit',
      transfer: 'Transfer',
      totalPnL: 'Total PnL',
      tradeVolumeTitle: 'Volume (lots) / million USD',
      tradeCommission: 'Trade Commission',
      followCommission: 'Copy Commission',
      pammCommission: 'PAMM Commission',
      totalCommission: 'Total Commission',
    },
  },
}